import { CommonService } from 'src/services/common.service';
import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Filesystem, Directory } from '@capacitor/filesystem';

@Component({
  selector: 'app-helpdesk-attachment',
  templateUrl: './helpdesk-attachment.component.html',
  styleUrls: ['./helpdesk-attachment.component.scss'],
})
export class HelpdeskAttachmentComponent implements OnInit {
  @Input() _isDisputeForm: any;
  ticketDocTypeList;
  disputeDocTypeList;
  selectedDocType;
  optionField;
  fileData;
  data: any = {
    userOption: '',
    file: '',
    docKey: ''
  };
  filename: string = '';
  platform: any;
  isValidFileSize: boolean = false;
  constructor(
    private modelController: ModalController,
    public alert: AlertController,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.platform = this.commonService.getLocalPlatformDetail();
    if (this._isDisputeForm) {
      this.disputeDocTypeList = JSON.parse(localStorage.getItem("disputeDocTypeList"));
      this.optionField = Object.values(this.disputeDocTypeList);
    } else {
      this.ticketDocTypeList = JSON.parse(localStorage.getItem("ticketDocTypeList"));
      this.optionField = Object.values(this.ticketDocTypeList);
    }

  }

  onFileSelected(event) {
    this.fileData = event.target.files[0];
    this.filename = this.fileData.name;
    this.isValidFileSize = this.commonService.fileValidation(this.fileData.size);
  }
  cancel() {
    this.data.userOption = 'cancel';
    this.modelController.dismiss(this.data);
  }
  //-------------------------------For upload captured image----------------------------------------------------

  chooseFile() {
    this.simpleConfirm1('Please select option to upload!', 'You can use Camera or Gallery to upload photo');
  }

  async simpleConfirm1(headerVal: string, messageVal: string) {
    const alert = await this.alert.create({
      cssClass: 'my-custom-class',
      mode: 'ios',
      header: headerVal,
      message: messageVal,
      buttons: [
        {
          text: 'Camera',
          handler: () => {
            this.selectImage();
          }
        },
        {
          text: 'Gallery',
          handler: () => {
            this.pickImageFromGallery();
          }
        },
        {
          text: 'Cancel',
          handler: () => {

          }
        }
      ]
    });
    await alert.present();
  }

  async pickImageFromGallery() {
    const image = await Camera.getPhoto({
      quality: 70,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Photos // Camera, Photos or Prompt!
    });

    if (image) {
      this.saveImage(image.dataUrl);
    }
  }

  async selectImage() {
    const image = await Camera.getPhoto({
      quality: 70,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Camera // Camera, Photos or Prompt!
    });

    if (image) {
      this.saveImage(image.dataUrl);
    }
  }

  async saveImage(image) {
    const fileName = new Date().getTime() + '.jpeg';
    const savedFile = await Filesystem.writeFile({
      path: fileName,
      data: image,
      directory: Directory.Documents
    });
    this.fileData = await this.dataURLtoFile(image, fileName);
    this.filename = fileName;
    this.isValidFileSize = this.commonService.fileValidation(this.fileData.size);
  }



  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = dataurl.split(';')[0].split(':')[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  //-----------------------------------------------------------------------------------

  confirm() {
    if (this._isDisputeForm) {
      const key = Object.keys(this.disputeDocTypeList).find(key => this.disputeDocTypeList[key] === this.selectedDocType);
      this.data.docKey = key;
    } else {
      const key = Object.keys(this.ticketDocTypeList).find(key => this.ticketDocTypeList[key] === this.selectedDocType);
      this.data.docKey = key;
    }
    this.data.file = this.fileData;
    this.data.userOption = 'confirm';
    this.modelController.dismiss(this.data);
  }
}
